import request from '@/config/axios'

/**
 * 酒店平台可管理店铺的精简信息。
 * 与商城店铺下拉接口隔离，避免把商城/O2O 店铺带入酒店页面。
 */
export interface HotelPlatformShopOption {
  id: string | number
  name: string
  operationMode?: string
  settleCycle?: string
  autoSettle?: number
}

/** 平台酒店列表行 / 详情 */
export interface HotelPlatformShopVO {
  shopId: string | number
  shopName: string
  shopStatus: number
  shopType?: number
  score?: number
  contactPhone?: string
  operationMode?: string
  settleCycle?: string
  autoSettle?: number
  checkInTime?: string
  checkOutTime?: string
  roomCount?: number
  orderCount?: number
}

export const getShopSimpleList = () =>
  request.get<HotelPlatformShopOption[]>({ url: '/hotel/platform/shop/simple-list' })

export const getAllHotelShopSimpleList = () =>
  request.get<HotelPlatformShopOption[]>({ url: '/hotel/platform/shop/all-simple-list' })

// 平台酒店列表分页（仅酒店业态）
export const getPlatformShopPage = (params: {
  pageNo: number
  pageSize: number
  shopName?: string
  shopStatus?: number
}) => request.get({ url: '/hotel/platform/shop/page', params })

// 平台酒店详情
export const getPlatformShopDetail = (shopId: string | number) =>
  request.get<HotelPlatformShopVO>({ url: '/hotel/platform/shop/get', params: { shopId } })
